import { Component } from '@angular/core';
import { LitigationComplaintsService } from './litigation-complaints.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToastMessageService } from 'src/app/toastr.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-litigation-complaints',
  templateUrl: './litigation-complaints.component.html',
  styleUrl: './litigation-complaints.component.scss'
})
export class LitigationComplaintsComponent {
  litigationData: any[] = [];
  filteredLitigationData: any[] = [];
  loading = true;
  selectedOption: string = 'pdf'; // Default to 'pdf'
  isButtonDisabled: boolean = false;
  dropdownOptions = [
    { label: 'Found in PDF', value: 'pdf' },
    { label: 'Not Found in PDF', value: 'not_found' },
    { label: 'No Innovator (Defendants Directory)', value: 'defendants_directory' },
    { label: 'No Pdf And No Case No.', value: 'not_found_pdf_case_no' },
    { label: 'On Hold', value: 'on_hold' },
    { label: 'Deleted Records', value: 'deleted' },
    {}
  ];
  displayDeleteDialog: boolean = false;
  recordToDelete: any;
  UserIp: any;
  email: any;
  selectedStatus: string | null = 'pending';
  selectedLitigationData: any[] = [];
  displayBulkRejectDialog: boolean = false;
  startdate: Date | undefined;
  enddate: Date | undefined;
  dateError: string = '';

  constructor(private LitigationComplaintsService: LitigationComplaintsService, private toastService: ToastMessageService,
    private sanitized: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.getlitigationData()
  }

  getlitigationData() {
    this.loading = true;
    this.LitigationComplaintsService.getLitigationComplaintsData(this.email).subscribe((response) => {
      this.litigationData = response["data"];
      console.log("litigationData", this.litigationData)
      this.filterLitigationData();
      this.loading = false;
    });
  }

  refreshData() {
    this.loading = true;
    this.getlitigationData();
    this.loading = false;
  }

  onOptionChange(event: any) {
    this.filterLitigationData();
  }

  onStatusChange(event: any) {
    this.selectedStatus = event.value; // Update the selected status
    this.filterLitigationData();
  }

  onStartDateChange(event: any) {
    console.log("Start Date Changed:", event);
    this.startdate = event; // Update the startdate
    this.filterLitigationData(); // Trigger filtering
  }

  onEndDateChange(event: any) {
    console.log("End Date Changed:", event);
    this.enddate = event; // Update the enddate
    this.filterLitigationData(); // Trigger filtering
  }

  filterLitigationData() {
    if (this.selectedOption === 'pdf') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Found in PDF' && !data['is_deleted'] && !data['onHold']);
      // this.showDeleteColumn = false;
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'not_found') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Not Found in PDF' && !data['is_deleted'] && !data['onHold'] && !(data['Case Number'] === '' && data['PDF File'] === 'N/A'));
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'defendants_directory') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Defendants Directory' && !data['is_deleted'] && !data['onHold']);
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'not_found_pdf_case_no') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Case Number'] === '' && data['PDF File'] === 'N/A' && data['Status'] === 'Not Found in PDF');
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData111", this.filteredLitigationData)
    } else if (this.selectedOption === 'Manual Entry') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Case Number'] === '' && data['PDF File'] === 'N/A' && data['Status'] === 'Manual Entry');
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData111", this.filteredLitigationData)
    } else if (this.selectedOption === 'on_hold') {
      this.filteredLitigationData = this.litigationData.filter(data => data['onHold'] === true);
    } else if (this.selectedOption === 'deleted') {
      this.filteredLitigationData = this.litigationData.filter(data => data['is_deleted'] === true);
    }

    if (this.startdate && this.enddate) {
      const start = new Date(this.startdate);
      const end = new Date(this.enddate);
      console.log("Datee", start, end);

      this.filteredLitigationData = this.filteredLitigationData.filter(data => {
        const recordDate = new Date(data['Field ID']); // Replace with your actual field
        return recordDate >= start && recordDate <= end;
      });
    }

    if (this.startdate > this.enddate) {
      this.dateError = 'Please select a proper date range. Start date cannot be greater than end date.';
      return; // Prevent further execution
    } else {
      this.dateError = ''; // Clear the error
    }

    console.log("Filtered Litigation Data", this.filteredLitigationData);
  }

  clearDates() {
    this.startdate = undefined;
    this.enddate = undefined;
    this.filterLitigationData();
  }

  openPdf(value) {
    let url: any = window.open(`${environment.ip}pm_backend/${value}`);
    // let url: any = window.open(`http://3.111.249.237/pm_backend/${value}`);
    // let url: any = window.open(`http://3.111.95.5/pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }
}
